import React, { useEffect, useMemo } from "react";
import Sidebar from "./side-bar/side-bar";
import { MenuItem, Permission } from "./side-bar/types/menu-items";
import "./preneed-main-layout.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { footerItems, menuItems } from "./side-bar/types/side-bar";
import { getPreneedBookingAppointmentLeads } from "../../api/preneed-section/preneed-booking-appointment.api";

const PreneedMainLayout: React.FC = () => {
  const SUPER_TENANT = "SuperTenant";

  //  Preneed permissions (adjust reducer key if your state name differs)
  const permissions = useSelector(
    (state: any) => state?.session?.preNeedDetails?.roles?.rolePermissions
  );

  const preNeedDetails = useSelector((state: any) => state?.session?.preNeedDetails);
  const dispatch = useDispatch();

  const currentUserRoleId = useMemo(() => {
    return preNeedDetails?.roles?.id;
  }, [preNeedDetails]);

  const currentUserType = preNeedDetails?.tenantDetails?.tenantType;

  const filterMenuByPermissions = (
    menuItems: MenuItem[] | undefined,
    permissions: Permission[]
  ): MenuItem[] => {
    if (!menuItems) return [];

    return menuItems.filter((menu) => {
      const module: any = permissions?.find(
        (perm: any) => perm?.resource === menu?.moduleName
      );

      let hasMainMenuPermission = false;

      if (!menu.moduleName) {
        hasMainMenuPermission = true;
      } else if (module) {
        hasMainMenuPermission = !module.scopes || module.scopes.read === true;
      }

      if (
        menu?.permissionRole?.length &&
        !menu.permissionRole.includes(currentUserRoleId)
      ) {
        return false;
      }

      if (menu?.onlyShowTOAFP) {
        return currentUserType === SUPER_TENANT && hasMainMenuPermission;
      }

      if (menu.subMenu) {
        menu.subMenu = filterMenuByPermissions(
          menu.subMenu,
          module?.subresources
        );
        return hasMainMenuPermission && menu.subMenu.length > 0;
      }

      return hasMainMenuPermission;
    });
  };

  // Same cloning approach as AdminMainLayout
  const filterMenu = _.cloneDeep(menuItems);
  const footerMenu = _.cloneDeep(footerItems);

  //  If you want permission filtering active for preneed, use this:
  // const menuFilterItems = filterMenuByPermissions(filterMenu, permissions || []);
  // const footerFilterItems = filterMenuByPermissions(footerMenu, permissions || []);

  //  If permission filtering not required yet (same as your provider file):
  const menuFilterItems = filterMenu;
  const footerFilterItems = footerMenu;

    const fetchLeads = async (type: string) => {
        try {
          const response = await getPreneedBookingAppointmentLeads();
          if (response.data?.success) {
            const count = response.data?.data?.data?.totalRecords || 0;
            dispatch({ 
              type: `LEAD:${type}`,
               payload: { count } 
            });
          }
        } catch (err) {
        } 
    };
   
    useEffect(() => {
      fetchLeads("INITIALIZE_PLANNER_LEAD_COUNT");
      const intervalLead = setInterval(() => {
        fetchLeads("SET_PLANNER_LEAD_COUNT");
      }, 300000);
  
      return () => clearInterval(intervalLead);
    }, []);

  return (
    <>
      {/*  No ProviderSessionWarningToast here */}
      <Sidebar menuItems={menuFilterItems} footerItems={footerFilterItems} />
    </>
  );
};

export default PreneedMainLayout;
